<template>
  <form @submit.prevent="submit">
    <div class="row">
      <div class="col-md-4">
        <z-input
          v-model="orgname"
          name="orgname"
          label="Name"
          validate="required"
          @keyup="saveIt"
        />
      </div>
      <div v-if="isShowGroupCode" class="col-md-4">
        <z-input
          v-model="orgcode"
          name="orgcode"
          label="Group Code"
          validate="required"
          @keyup="saveIt"
        />
      </div>
      <div v-if="isShowGroupCode" class="col-md-4">
        <div class="form-group custom-check">
          <input
            type="checkbox"
            id="isActive"
            v-model="isActive"
            class="z-checkbox-small"
            @click="saveIt"
          />
          <label for="isActive" class="custom-allow">active?</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <z-select v-model="openDay" :options="days" label="Day Open" />
      </div>
      <div class="col-md-3">
        <z-select v-model="closeDay" :options="days" label="Day Close" />
      </div>
      <div class="col-md-3">
        <z-input
          v-model="timeOpen"
          name="timeOpen"
          label="Time Open"
          @keyup="saveIt"
        />
      </div>
      <div class="col-md-3">
        <z-input
          v-model="timeClose"
          name="timeClose"
          label="Time Close"
          @keyup="saveIt"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <label class="form-label" for="organizationEid">Eid:</label>
        <span id="organizationEid" class="custom-id">{{ eid }}</span>
      </div>
      <div class="col-md-6"></div>
    </div>
  </form>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZInput from '@/Components/ZElements/Input'
import ZSelect from '@/Components/ZElements/Select'
import globals from '@/Plugins/globals'
export default {
  name: 'organization-basic',
  components: {
    ZInput,
    ZSelect,
  },
  data() {
    return {
      days: [
        {
          id: 1,
          name: 'Sunday',
          value: 'Sunday',
        },
        {
          id: 2,
          name: 'Monday',
          value: 'Monday',
        },
        {
          id: 3,
          name: 'Tuesday',
          value: 'Tuesday',
        },
        {
          id: 4,
          name: 'Wednesday',
          value: 'Wednesday',
        },
        {
          id: 5,
          name: 'Thursday',
          value: 'Thursday',
        },
        {
          id: 6,
          name: 'Friday',
          value: 'Friday',
        },
        {
          id: 7,
          name: 'Saturday',
          value: 'Saturday',
        },
      ],
    }
  },
  computed: {
    ...mapGetters('organizations', ['organization']),
    ...mapGetters('users', ['isFeatureAllowed']),
    id() {
      let _data = null
      if (this.organization) {
        _data = this.organization.id
      }
      return _data
    },
    eid() {
      let _data = null
      if (this.organization) {
        _data = this.organization.uid
      }
      return _data
    },
    orgname: {
      get() {
        let _data = ''
        if (this.organization) {
          _data = this.organization.orgName
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'orgName',
          value: value,
        })
      },
    },
    orgcode: {
      get() {
        let _data = ''
        if (this.organization) {
          _data = this.organization.orgCode
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'orgCode',
          value: value,
        })
      },
    },
    isActive: {
      get() {
        let _data = false
        if (this.organization) {
          _data = this.organization.isActive === 1 ? true : false
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'isActive',
          value: value ? 1 : 0,
        })
      },
    },
    openDay: {
      get() {
        let _data = ''
        if (this.organization) {
          _data = this.organization.storeDaysOpen
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'storeDaysOpen',
          value: value,
        })
      },
    },
    closeDay: {
      get() {
        let _data = ''
        if (this.organization) {
          _data = this.organization.storeDaysClose
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'storeDaysClose',
          value: value,
        })
      },
    },
    timeOpen: {
      get() {
        let _data = ''
        if (this.organization) {
          _data = this.organization.storeHoursOpen
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'storeHoursOpen',
          value: value,
        })
      },
    },
    timeClose: {
      get() {
        let _data = ''
        if (this.organization) {
          _data = this.organization.storeHoursClose
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'storeHoursClose',
          value: value,
        })
      },
    },
    isShowGroupCode() {
      let _data = false
      if (this.isFeatureAllowed('organization_groupcode')) {
        _data = true
      }
      return _data
    },
  },
  methods: {
    ...mapActions('organizations', ['setOrganizationData']),
    saveIt() {
      this.$emit('saveIt')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-id {
  padding-left: 5px;
}
.custom-check {
  position: relative;
  top: 30px;
}
</style>
